export default __webpack_public_path__ + "static/Montserrat-VariableFont_wght-7e687123cd4528224ce5a4daf9a8141e.ttf";